// extracted by mini-css-extract-plugin
module.exports = {"event":"event-23mEU","eventInfo":"eventInfo-1j43R","leftColumn":"leftColumn-3ffNP"};